import React from 'react';
import { AlteracaoIbsCbsLoteContent } from './AlteracaoIbsCbsLoteContent';
import { AlteracaoIbsCbsLoteProvider } from './context/AlteracaoIbsCbsLoteContext';

export const AlteracaoIbsCbsEmLote: React.FC = () => {
  return (
    <AlteracaoIbsCbsLoteProvider>
      <AlteracaoIbsCbsLoteContent />
    </AlteracaoIbsCbsLoteProvider>
  );
};
